import { GridRegular, ListRegular } from '@/components/Icon'
import styles from './documentsPage.module.scss'

/** @typedef {import('./documentsConstants').DocumentsViewMode} DocumentsViewMode */

/**
 * @param {{
 *   view: DocumentsViewMode,
 *   onViewChange: (view: DocumentsViewMode) => void,
 * }} props
 */
export default function DocumentsViewToggle({ view, onViewChange }) {
  return (
    <div className={styles.viewToggleGroup} role="group" aria-label="Document view">
      <button
        type="button"
        className={`${styles.viewToggleButton}${view === 'grid' ? ` ${styles.viewToggleButtonActive}` : ''}`}
        aria-pressed={view === 'grid'}
        aria-label="Grid view"
        onClick={() => onViewChange('grid')}
      >
        <GridRegular className={styles.viewToggleIcon} aria-hidden />
      </button>
      <button
        type="button"
        className={`${styles.viewToggleButton}${view === 'list' ? ` ${styles.viewToggleButtonActive}` : ''}`}
        aria-pressed={view === 'list'}
        aria-label="List view"
        onClick={() => onViewChange('list')}
      >
        <ListRegular className={styles.viewToggleIcon} aria-hidden />
      </button>
    </div>
  )
}
